import {
  CustomerSettings,
  GetCustomerSettingsRequest,
} from "../../api/grpc/customer/customer";
import { useCustomerRequests } from "../../api/grpc/customer/useCustomerRequests";
import useGrpcQuery from "./useGrpcQuery";

export const useGlobalWorkingHours = () => {
  const { getCustomerSettings } = useCustomerRequests();

  const {
    loading,
    data: customerSettings,
    refetch,
    error,
  } = useGrpcQuery<GetCustomerSettingsRequest, CustomerSettings>({
    method: getCustomerSettings,
    variables: {
      customerId: "",
    },
  });

  const deskBookingEnabled = customerSettings?.deskBookingEnabled;
  const roomBookingEnabled = customerSettings?.roomBookingEnabled;

  return {
    loading,
    customerSettings,
    refetch,
    error,
    deskBookingEnabled,
    roomBookingEnabled,
  };
};
